const duplicatePax = (pax, current) => {
  let ret = [];
  pax.map((item) => {
    const newItem = {...item}
    if (current) {
      const currentEntry = current.find((i) => { return i.id === newItem.id });
      if (currentEntry) {
        newItem.value = currentEntry.value;
      }
    }
    ret.push(newItem);
  })
  return ret;
}

export default duplicatePax;
